export enum Experience {
	AGRITOURISM = 'AGRITOURISM',
	ART_CULTURE = 'ART_CULTURE',
	CHILD_FRIENDLY = 'CHILD_FRIENDLY',
	CITYTRIP = 'CITYTRIP',
	RELAX_WELLNESS = 'RELAX_WELLNESS',
	REST_NATURE = 'REST_NATURE',
	SILENCE_REST = 'SILENCE_REST',
	SPORT_EXERCISE = 'SPORT_EXERCISE',
	WATER = 'WATER',
}

export const EXPERIENCES = [
	Experience.AGRITOURISM,
	Experience.CITYTRIP,
	Experience.CHILD_FRIENDLY,
	Experience.ART_CULTURE,
	Experience.REST_NATURE,
	Experience.RELAX_WELLNESS,
	Experience.SPORT_EXERCISE,
	Experience.SILENCE_REST,
	Experience.WATER,
];
